import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    models: [ 
        {
         value: 'F16',
         name: 'NISSAN JUKE',
         image: '/static/nissan-juke.jpg'
       },
       {
        value: 'J12',
        name: 'NISSAN QASHQAI',
        image: '/static/novi-nissan-qashqai.jpg'
      },
      {
        value: 'T33',
        name: 'NISSAN X-TRAIL',
        image: '/static/nisssan-xtrail-tekna-2022.png'
      }
    ],
    dealers: [
      {
        'name': 'AK Kompresor - prodaja automobila d.o.o.',
        'bir': 89150075,
        address: {
          'line1': 'Žorža Klemansoa 19',
          'line2': '',
          'line3': '',
          'line4': '',
          'city': 'Beograd',
          'zip': 11000
        },
        pos: {
          'lat': 44.7869605,
          'lng': 20.4227988
        },
        work: {
          'mon': '09:00 - 19:00',
          'tue': '09:00 - 19:00',
          'wed': '09:00 - 19:00',
          'thu': '09:00 - 19:00',
          'fri': '09:00 - 19:00',
          'sat': '09:00 - 15:00',
          'sun': 'Zatvoreno'
        }
      },
      {
        'name': 'Auto Marton d.o.o.',
        'bir': 410013,
        address: {
          'line1': 'Batinska 6',
          'line2': '',
          'line3': '',
          'line4': '',
          'city': 'Subotica',
          'zip': 24000
        },
        pos: {
          'lat': 46.0848407,
          'lng': 19.6342463
        },
        work: {
          'mon': '08:00 - 17:00',
          'tue': '08:00 - 17:00',
          'wed': '08:00 - 17:00',
          'thu': '08:00 - 17:00',
          'fri': '08:00 - 17:00',
          'sat': '08:00 - 14:00',
          'sun': 'Zatvoreno'
        }
      },
      {
        'name': 'LADY F d.o.o. - LF Auto Centar',
        'bir': 410018,
        address: {
          'line1': 'Novosadski autoput 73 A',
          'line2': '',
          'line3': '',
          'line4': '',
          'city': 'Zemun',
          'zip': 11080
        },
        pos: {
          'lat': 44.8571898,
          'lng': 20.3582343
        },
        work: {
          'mon': '09:00 - 18:00',
          'tue': '09:00 - 18:00',
          'wed': '09:00 - 18:00',
          'thu': '09:00 - 18:00',
          'fri': '09:00 - 18:00',
          'sat': '09:00 - 14:00',
          'sun': 'Zatvoreno'
        }
      },
      {
        'name': 'Stojanov Auto d.o.o.',
        'bir': 89150183,
        address: {
          'line1': 'Zrenjaninski put 12',
          'line2': '',
          'line3': '',
          'line4': '',
          'city': 'Novi Sad',
          'zip': 21000
        },
        pos: {
          'lat': 45.2910898,
          'lng': 19.8517043
        },
        work: {
          'mon': '08:00 - 18:00',
          'tue': '08:00 - 18:00',
          'wed': '08:00 - 18:00',
          'thu': '08:00 - 18:00',
          'fri': '08:00 - 18:00',
          'sat': '08:00 - 12:30',
          'sun': 'Zatvoreno'
        }
      },
      {
        'name': 'HIT AUTO D.O.O.',
        'bir': 89150020,
        address: {
          'line1': 'Staro Sajmište 29',
          'line2': '',
          'line3': '',
          'line4': '',
          'city': 'BEOGRAD',
          'zip': 11000
        },
        pos: {
          'lat': 44.8127846,
          'lng': 20.4385706
        },
        work: {
          'mon': '08:00 - 17:00',
          'tue': '08:00 - 17:00',
          'wed': '08:00 - 17:00',
          'thu': '08:00 - 17:00',
          'fri': '08:00 - 17:00',
          'sat': '09:00 - 14:00',
          'sun': 'Zatvoreno'
        }
      },
      {
        'name': 'Nikom Cars',
        'bir': 89150189,
        address: {
          'line1': 'Industrijska 20',
          'line2': '',
          'line3': '',
          'line4': '',
          'city': 'Kragujevac',
          'zip': 34000
        },
        pos: {
          'lat': 44.026744,
          'lng': 20.94531
        },
        work: {
          'mon': '09:00 - 17:00',
          'tue': '09:00 - 17:00',
          'wed': '09:00 - 17:00',
          'thu': '09:00 - 17:00',
          'fri': '09:00 - 17:00',
          'sat': '08:00 - 14:00',
          'sun': 'Zatvoreno'
        },
		electric: true
      },
    ],
    titles: [
      'GDIN',
      'GĐA',
      'GĐICA'
    ],
    times: [
      '8:00',
      '9:00',
      '10:00',
      '11:00',
      '12:00',
      '13:00',
      '14:00',
      '15:00',
      '16:00',
      '17:00'
    ],
    monthsLong: [
      'Januar',
      'Februar',
      'Marec',
      'April',
      'Maj',
      'Junij',
      'Julij',
      'Avgust',
      'September',
      'Oktober',
      'November',
      'December'
    ],
    monthsShort: [
      'Jan',
      'Feb',
      'Mar',
      'Apr',
      'Maj',
      'Jun',
      'Jul',
      'Avg',
      'Sep',
      'Okt',
      'Nov',
      'Dec'
    ],
    dateNamesMin: [
      'Ne',
      'Po',
      'To',
      'Sr',
      'Če',
      'Pe',
      'So'
    ],
    dateNamesShort: [
      'Ned',
      'Pon',
      'Tor',
      'Sre',
      'Čet',
      'Pet',
      'Sob'
    ],
    dateNamesLong: [
      'Nedelja',
      'Ponedeljek',
      'Torek',
      'Sreda',
      'Četrtek',
      'Petek',
      'Sobota'
    ],
    services: [
      {
        value: 'VzdrzevalniPregled',
        name: 'Vzdrževalni pregled'
      },
      {
        value: 'PopraviloSistemskeNapake',
        name: 'Popravilo sistemske napake'
      },
      {
        value: 'DodatnaOprema',
        name: 'Dodatna oprema'
      },
      {
        value: 'ClanstvoZvestoNaCesto',
        name: 'Članstvo v programu Zvesto na cesto'
      },
      {
        value: 'InformacijeoPaketih',
        name: 'Informacije o paketih'
      },
      {
        value: 'PogodbaoVzdrzevanju',
        name: 'Pogodba o vzdrževanju'
      },
      {
        value: 'PopraviloKaroserije',
        name: 'Popravilo karoserije'
      },
      {
        value: 'Pnevmatike',
        name: 'Pnevmatike'
      },
      {
        value: 'VetrobranskoSteklo',
        name: 'Vetrobransko steklo'
      },
      {
        value: 'Drugo',
        name: 'Drugo'
      }
    ]
  },
  getters: {
  },
  mutations: {
  }
})



// WEBPACK FOOTER //
// ./src/store/dropdowns.js